export class UtilHelper {
  public static trimString(str: string, requiredLength: number): string {
    const trimmedString = str.substring(0, requiredLength);
    return trimmedString;
  }
}
